import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, useIonModal, IonButton, IonItemSliding, IonList, IonItemOptions, IonItemOption, useIonAlert } from '@ionic/react';
import { useState, useEffect } from 'react';
import ExploreContainer from '../components/ExploreContainer';
import './Clients.css';

import { chatbox, chatboxEllipsesOutline, ellipse, personAddOutline } from 'ionicons/icons';
import { OverlayEventDetail } from '@ionic/core/components';
import { useHistory } from 'react-router';
import { addClientListener, getClientByPhone, getClientNameFromPhoneContacts } from '../firebase/clients';
import { addSmsGroupListener, getMoreSmsGroups, updateSmsGroup } from '../firebase/smsGroup';
import { getMoreSmses } from '../firebase/sms';

import dateFormat from 'dateformat';

export function getUserNameByPhone(number: string) {
  const c = getClientByPhone(number);
  if (c !== undefined) {
    if (c.phone.length >= 9 && number.includes(c.phone)) {
      return c.surname + " " + c.name + " (" + number.replace("0048", "") + ")";
    } else if (c.gphone.length >= 9 && number.includes(c.gphone)) {
      return c.gsurname + " " + c.gname + " (" + number.replace("0048", "") + ")";
    }
  } else {
    var name = getClientNameFromPhoneContacts(number);
    if (name !== undefined) {
      return name + " * (" + number.replace("0048", "") + ")";
    }
    return number.replace("0048", "");
  }

}

const SmsPage: React.FC = () => {
  const [clients, setClients] = useState([]);
  const [presentAlert] = useIonAlert();
  const [presentAlert2] = useIonAlert();
  const history = useHistory();
  const [smses, setSmses] = useState<any[]>([]);

  useEffect(() => {
    addSmsGroupListener((list: any) => {
      setSmses(list);
    });

    //nie wykorzystuje klientów bezpośrednio, ale dzięki temu odświea mi się nazwa na liście smsmów
    addClientListener((list: any) => {
      setClients(list);
    })
  }, []);



  function changeReaded(sms: any, readed: undefined | boolean = undefined) {
    if (readed !== undefined) {
      sms.new = readed;
    } else {
      sms.new = !sms.new;
    }
    updateSmsGroup(sms);
  }

  function closeSlide(id: string) {
    var obj = document.getElementById(id);
    if (obj !== null) {
      //@ts-ignore
      obj.close()
    }

  }

  function getPhoneNumberForSms(str: string) {
    if (str.length >= 9) {
      if (/^\d+$/.test(str)) {
        if (str.length === 9) {
          str = "0048" + str;
        }
        if (str.length === 11) {
          str = "00" + str;
        }
        return str;
      }
    }
    return undefined;

  }

  function newSms() {
    presentAlert({
      header: 'Nr telefonu',
      inputs: [
        {
          name: 'number',
          placeholder: 'telefon'
        }
      ],
      buttons: [
        {
          text: 'Anuluj',
          role: 'cancel'
        },
        {
          text: 'OK',
          role: 'confirm',
        },
      ],
      onDidDismiss: (e: CustomEvent) => {
        if (e.detail.role === 'confirm') {
          var number = e.detail.data.values.number;
          number = getPhoneNumberForSms(number);
          if (number !== undefined) {
            history.push("/app/smses/" + number)
          } else {
            presentAlert2({
              header: 'Niepoprawny nr telefonu!',
              buttons: [
                {
                  text: 'OK'
                },
              ],
            })
          }
        }
      },
    })

  }

  async function readMoreSmsGroups() {
    var smsListNew: any[] = await getMoreSmsGroups();
    if (smsListNew.length > 0) {
      setSmses([...smses, ...smsListNew]);
    }
  }

  function formatDate(date: any) {
    let d = new Date();
    let sd = date.toDate();
    if(d.getDate() === sd.getDate() && d.getMonth() === sd.getMonth() && d.getFullYear() === sd.getFullYear()){
      return dateFormat(date.toDate(), "HH:MM");
    }else{
      return dateFormat(date.toDate(), "yyyy-mm-dd");
    }
    
  }

  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonTitle>SMS</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>

        <IonList>
          {smses.map((s: any) => (
            <IonItemSliding key={"s-" + s.id} id={"sliding-" + s.id}>
              <IonItemOptions side="start">
                <IonItemOption onClick={(e) => { changeReaded(s); closeSlide("sliding-" + s.id); }}>{s.new ? "Przeczytana" : "Nowa"}</IonItemOption>
              </IonItemOptions>
              <IonItem onClick={(e) => changeReaded(s, false)} routerLink={"/app/smses/" + s.id} key={s.id} >
                {s.new ? <IonIcon icon={ellipse} style={{ color: "#488aff" }} /> : ""}
                <div style={{ minWidth: "20px", color: "gray", fontSize: "12px", position: "absolute", top: "0px", right: "10px" }}>{formatDate(s.updated)}</div>
                <IonLabel>{getUserNameByPhone(s.id)}</IonLabel>
              </IonItem>
            </IonItemSliding>
          ))}
        </IonList>
        
        {smses.length > 0 && smses.length % 30 === 0 ? <div style={{ textAlign: "center" }}><IonButton onClick={() => { readMoreSmsGroups() }}>wczytaj kolejne numery</IonButton></div> : ""}
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => { newSms() }}>
            <IonIcon icon={chatboxEllipsesOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default SmsPage;
